import type { FlightSearchCriteria } from "@/features/flights/types/types";
import type { FlightSearchFormValues } from "@/features/flights/utils/flightsValidation";
import { getDateString } from "@/utils/dates";
import { getCityName } from "@/utils/locations";

export function buildFlightSearchCriteria(
  searchData: FlightSearchFormValues,
): FlightSearchCriteria {
  return {
    tripType: searchData.tripType,
    departure_city: getCityName(searchData.from) || undefined,
    destination: getCityName(searchData.to) || undefined,
    travel_date: getDateString(searchData.dates.departure),
    return_date: searchData.dates.return
      ? getDateString(searchData.dates.return)
      : undefined,
    travellers: searchData.adult + searchData.child,
  };
}
